<template>
  <div :class="showMenu ? 'm-main-dialog': 'm-main'">
    <transition name="slide-fade">
    <div class="dialogMenu" v-show="showMenu">
      <div class="header">
        <div class="box">
          <!--        <div style="width: 40px"></div>-->
          <div class="logo"><img src="../../assets/logo-w.png" alt="" style="width: 140px;" @click="jumpPath('/m')"></div>
          <div class="menu"><img src="../../assets/m/close.png" alt="" style="width: 14px; height: 14px" @click="showMenu = false"></div>
          <!--        <div style="width: 40px"></div>-->
        </div>
      </div>
      <div class="menu-line" style="margin-top: 96px"></div>
      <div class="menu-txt" @click="jumpPath('/m/mProducts')">{{ zh === 'ja' ? zhJson.header.ja[0] : zhJson.header.en[0] }}</div>
      <div class="menu-line"></div>
      <div class="menu-txt" @click="jumpPath('/m/mClients')">{{ zh === 'ja' ? zhJson.header.ja[1] : zhJson.header.en[1] }}</div>
      <div class="menu-line"></div>
      <div class="menu-txt" @click="jumpPath('/m', 'contact')"><a href="#contact">{{ zh === 'ja' ? zhJson.header.ja[2] : zhJson.header.en[2] }}</a></div>
      <div class="menu-line"></div>
      <div class="menu-txt">
        <el-dropdown @command="handleZh">
          <span class="el-dropdown-link">{{ zh === 'ja' ? '日本語' : 'English' }}<i class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="en">English</el-dropdown-item>
            <el-dropdown-item command="ja">日本語</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    </transition>
    <div class="header" v-show="!showMenu">
      <div class="box">
<!--        <div style="width: 40px"></div>-->
        <div class="logo"><img src="../../assets/logo.png" alt="" style="width: 140px;" @click="jumpPath('/m')"></div>
        <div class="menu"><img src="../../assets/m/menu-group.png" alt="" style="width: 18px; height: 13px" @click="showMenu = true"></div>
<!--        <div style="width: 40px"></div>-->
      </div>
    </div>
    <router-view/>
  </div>
</template>
å
<script>
export default {
  name: "index",
  components: {},
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      showMenu: false,
      zh: '',
      zhJson: {
        header: {
          en: ['Products', 'Our Clients', 'Contact Us'],
          ja: ['製品情報', '導入事例', 'お問い合わせ']
        },
      }
    }
  },
  methods: {
    testAxios() {
      this.axios({
        method: 'get',//post
        url: 'api/',
        params: {}//data: {}
      }).then((response) => {
        const result = response.data;
        if (result.code === 0) {
        } else {
        }
      })
    },
    handleZh(command) {
      if (this.zh !== command) {
        this.zh = command;
        this.showMenu = false;
        this.$router.push({ path: this.$route.path, query: {'zh': command} });
      }
    },
    jumpPath(path, id) {
      this.showMenu = false;
      this.$router.push({ path: path, query: {'zh': this.zh, 'id': id} });
    },
  },
  mounted() {
    if (this.$route.query.zh && (this.$route.query.zh === 'en' || this.$route.query.zh === 'ja')) {
      this.zh = this.$route.query.zh;
    } else {
      this.zh = 'en';
    }
  }
}
</script>

<style lang="less" scoped>
//.dialogMenu ::after {content: "";width: 100%; height: 100vh; position: fixed;top: 0;right: 0;bottom: 0;left: 0; z-index: 2;background-color: rgba(0, 0, 0, 0.2);}

  .m-main-dialog {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      backdrop-filter: blur(7px);
    }
  }

  .dialogMenu {
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background: linear-gradient(156.42deg, rgba(37, 187, 222, 0.8) 23.02%, rgba(17, 236, 160, 0.8) 82.55%);
    //backdrop-filter: blur(1px);

    .menu-line {
      width:100%;

      opacity: 0.3;
      border: 1px solid #FFFFFF;
    }
    .menu-txt {
      margin: 20px 0 20px 39px;
      height: 16px;

      font-family: 'PP Neue Machina',serif;
      font-style: normal;
      //font-weight: 800;
      font-size: 16px;
      line-height: 16px;
      color: #FFFFFF;
    }
  }

  .header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;

    .box {
      margin-top: 40px;
      display: flex;
      justify-content: center;

      .menu {
        margin-left: 150px;
      }
    }
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/m/index.vue